import { create } from 'zustand'

type Severity = 'success' | 'info' | 'warn' | 'error'

interface Toast {
  id: string
  severity: Severity
  summary: string
  detail?: string
}

interface ToastState {
  toasts: Toast[]
  show: (severity: Severity, summary: string, detail?: string) => void
  dismiss: (id: string) => void
}

let nextId = 0

export const useToastStore = create<ToastState>()((set) => ({
  toasts: [],
  show: (severity, summary, detail) => {
    const id = String(++nextId)
    set((state) => ({
      toasts: [...state.toasts, { id, severity, summary, detail }],
    }))
    // Auto-dismiss after 5 seconds; an error after 15 (it often carries the server's whole sentence, e.g. why
    // an order move was refused) — and any toast closes at once from its own button (ToastHost).
    setTimeout(
      () => {
        set((state) => ({
          toasts: state.toasts.filter((t) => t.id !== id),
        }))
      },
      severity === 'error' ? 15000 : 5000,
    )
  },
  dismiss: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}))
